import { render, staticRenderFns } from "./DisplayIconBadgeTooltip.vue?vue&type=template&id=21496a94"
import script from "./DisplayIconBadgeTooltip.vue?vue&type=script&lang=js"
export * from "./DisplayIconBadgeTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports